'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var modal = context.getElement('.' + context.className + '_Modal');
  var closeButton = context.getElement('.' + context.className + '_CloseButton');
  var openButton = context.getElement('.' + context.className + '_OpenButton');

  modal.addEventListener('click', function (event) {
    if (event.target !== modal) return;

    modal.setAttribute('aria-current', 'false');
  });

  closeButton.addEventListener('click', function () {
    modal.setAttribute('aria-current', 'false');
  });

  openButton.addEventListener('click', function () {
    modal.setAttribute('aria-current', 'true');
  });
}